import { militaryMessagesEN } from './lib/intl/en-US';

export const programId = '5eebfb032010fe1b3f4623b2';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': militaryMessagesEN,
    },
};
